import { objectValues } from "@ea/shared_components/utils/object";
import virtualUserPoolEpicsMap from "./virtualUserPool.epics";
import * as virtualUserPoolReducers from "./virtualUserPool.reducers";

const virtualUserPoolEpics = objectValues(virtualUserPoolEpicsMap);

export { virtualUserPoolEpics, virtualUserPoolReducers };
